import api from '../api';
import Cookies from 'js-cookie';
import { setTokenCookie } from '../utils/jwt';

export interface AdminLoginPayload {
  email: string;
  password: string;
}

export async function adminLogin(payload: AdminLoginPayload) {
  const response = await api.post('/admin', payload);
  if (response.data.success) {
    const { accessToken, refreshToken } = response.data.data.tokens;
    // Use JWT expiration time from token instead of hardcoded values
    setTokenCookie('accessToken', accessToken, true);
    setTokenCookie('refreshToken', refreshToken, true);
  }
  return response.data;
}

// Admin forgot password
export async function adminForgotPassword(email: string) {
  const response = await api.post('/admin/forgot-password', { email });
  return response.data;
}

// Admin reset password
export async function adminResetPassword({ password, confirmPassword, token }: { password: string; confirmPassword: string; token: string }) {
  const response = await api.post('/admin/reset-password', { password, confirmPassword, token });
  return response.data;
}

export async function viewAdminProfile() {
  const accessToken = Cookies.get('accessToken');
  if (!accessToken) throw new Error('No access token found');
  const response = await api.get('/admin/view-profile', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
}

export async function getDashboardStats(statsDate: string) {
  const accessToken = Cookies.get('accessToken');
  if (!accessToken) throw new Error('No access token found');
  const response = await api.get('/admin/dashboard', {
    params: { statsDate },
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
}

// Add more admin-related API functions here as needed 